import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import ExternalLink from 'app/src/elements/ExternalLink';

const PRIVACY_URL =
  'https://www.termsfeed.com/live/cd6b23e4-3e1b-4a5e-b4f8-f88ed0f8175e';

const Container = styled(View)`
  background-color: ${colors.header};
  padding: 20px;
`;

const FooterText = styled(Text)`
  color: white;
  font-size: 16px;
  margin-bottom: 6px;
`;

const Links = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`;

const Footer = () => {
  const { isMobile } = useContext(ClientContext);
  const [showTicket, setShowTicket] = useState(false);

  return (
    <Container>
      <FooterText>Keeping.Care</FooterText>

      <Links>
        <ExternalLink url={PRIVACY_URL}>
          <FooterText>Privacy Policy</FooterText>
        </ExternalLink>
      </Links>
    </Container>
  );
};

export default Footer;
